<template>
  <div class="mt-3">
    <div class="conference-list">
      <div class="row row-item">
        <div
          v-for="(conference, indexConference) in conferenceProjectList"
          :key="indexConference"
          class="conference-frame"
        >
          <div class="relate">
            <div class="conference-detail">
              <div>
                <figure>
                  <img
                    :src="conference.image"
                    alt=""
                    class="img-booking"
                    height="209px"
                  />
                </figure>
              </div>
              <div class="booking-detail">
                <p class="booking-title">{{ conference.title }}</p>
                <p class="conference-detail limited-lines">
                  {{ conference.detail }}
                </p>
                <div class="mt-2 booking-icon">
                  <img :src="'/static/icons/person-icon.svg'" alt="" />
                  <div class="booking-information">{{ conference.limit }}</div>
                </div>
                <div class="mt-1 booking-icon">
                  <img :src="'/static/icons/location-pin-icon.svg'" alt="" />
                  <div class="booking-information">
                    {{ conference.address }}
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-6">
                    <div class="title-information">ราคาเช่าห้อง</div>
                    <div class="price-information">
                      เริ่มต้น
                      <div class="booking-price">
                        {{ conference.conferencePrice }}
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="title-information">ราคาแพ็คเก็จสัมมนา</div>
                    <div class="price-information">
                      เริ่มต้น
                      <div class="booking-price">
                        {{ conference.conferencePricePackagePerUnit }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-side">
              <sc-button
                class="booking-button"
                variant="orange-cc"
                size="sm"
                @click="handleClickItemBooking(conference)"
                >จองห้อง</sc-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    "sc-button": ScButton,
  },
  props: {
    conferenceProjectList: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    handleClickItemBooking(itemBooking) {
      this.$router.replace({
        name: "BookingCreate",
        params: { conferenceId: itemBooking.conferenceId },
      })

      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

$radius-top: 12px 12px 0px 0px;
$radius-button: 0px 0px 12px 12px;

.conference-list {
}

.conference-detail {
  border-radius: $radius-top;
  background: $white;

  .booking-detail {
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
  }
}

.booking-title {
  color: $color-orange;
  font-size: 33px;
}

.img-booking {
  border-radius: $radius-top;
  width: 100%;
  box-shadow: 3px 0px 8px 0 rgba(0, 0, 0, 0.2);
}

.booking-information {
  display: inline;
  padding-left: 10px;
}

.title-information {
  font-weight: bold;
}

.price-information {
  color: $color-orange;
  font-size: $font-14;
}

.booking-price {
  padding: 5px;
  display: inline;
  font-size: $font-18;
  font-weight: bold;
}

.button-side {
  position: relative;
  width: 100%;
  height: 50px;
  background: $white;
  border-radius: $radius-button;
}

.booking-button {
  width: 95%;
  height: 40px;
  font-size: $font-16;

  margin-bottom: 10px;
}

.booking-icon {
  padding-left: 5px;
  padding-bottom: 5px;
}

.conference-frame {
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

.booking-information,
.conference-detail,
.title-information {
  font-size: $font-16;
}

.limited-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media screen and (min-width: $m-size) {
  .row-item {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 20px;
  }
}

@media screen and (min-width: $l-size) {
  .row-item {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media screen and (max-width: $m-size) {
  .row-item {
    display: grid;
    grid-gap: 20px;
  }

  .booking-information,
  .conference-detail,
  .title-information {
    font-size: $font-14;
  }

  .booking-title {
    font-size: 25px;
  }

  .price-information {
    font-size: $font-12;
  }

  .booking-price {
    font-size: $font-16;
  }
}
</style>
